import { useTranslation } from 'react-i18next'
import { Helmet } from 'react-helmet-async'

import type { StringVoidMap } from 'src/types'

export function Meta(props: {
  name: string
  titleVars?: StringVoidMap
  image?: string
}) {
  const { t } = useTranslation()
  return (
    <Helmet>
      <title>
        {t(`meta:${props.name}:title`, props.titleVars)}
        {t('meta:global:title_suffix')}
      </title>
      {props.image ? <meta property='og:image' content={props.image} /> : null}
    </Helmet>
  )
}
